export const ALERT_MODULE_NAME = 'alerts';

export const EMAIL_STATE_NAME = 'email';
export const PERMISSIONS_EMAIL_BANNER = 'permissionsEmailBanner';



// WEBPACK FOOTER //
// ./app/Alerts/constants.js